// @ts-strict-ignore
import { type FormEvent, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { closeModal } from 'loot-core/client/actions';
import { updateAccount } from 'loot-core/client/queries/queriesSlice';
import { SUPPORTED_CURRENCIES } from 'loot-core/src/shared/currencies';
import { type AccountEntity } from 'loot-core/src/types/models';

import { useDispatch } from '../../redux';
import { Button } from '../ui/button2';
import { InitialFocus } from '../common/InitialFocus';
import { InlineField } from '../common/InlineField';
import { Input } from '../ui/input2';
import {
  Modal,
  ModalButtons,
  ModalCloseButton,
  ModalHeader,
  ModalTitle,
} from '../ui/modal';
import { Select } from '../ui/select2';
import { View } from '../common/View';

type EditLocalAccountModalProps = {
  account: AccountEntity;
};

export function EditLocalAccountModal({ account }: EditLocalAccountModalProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [name, setName] = useState(account.name);
  const [currency, setCurrency] = useState<string>(account.currency || 'PEN');

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (name.trim() === '') return;

    dispatch(
      updateAccount({
        account: {
          ...account,
          name: name.trim(),
          currency,
        },
      }),
    );
    dispatch(closeModal());
  };

  return (
    <Modal name="edit-local-account">
      {({ state: { close } }) => (
        <>
          <ModalHeader
            title={<ModalTitle title={t('Edit Account')} shrinkOnOverflow />}
            rightContent={<ModalCloseButton onClick={close} />}
          />
          <View>
            <form onSubmit={onSubmit}>
              <InlineField label={t('Name')} width="100%">
                <InitialFocus>
                  <Input
                    name="name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    style={{ flex: 1 }}
                  />
                </InitialFocus>
              </InlineField>

              <InlineField label={t('Currency')} width="100%">
                <Select
                  value={currency}
                  onChange={setCurrency}
                  options={SUPPORTED_CURRENCIES}
                  style={{ flex: 1 }}
                />
              </InlineField>

              <ModalButtons>
                <Button onClick={close}>
                  <Trans>Cancel</Trans>
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  style={{ marginLeft: 10 }}
                >
                  <Trans>Save</Trans>
                </Button>
              </ModalButtons>
            </form>
          </View>
        </>
      )}
    </Modal>
  );
}
